import {
  INSTITUTION_SUCCESS,
  INSTITUTION_FAIL,
  LOAD_INSTITUTION
} from '../action.types';
import initialState from '../initial.state';

export default function(state = initialState.institution, action) {
  switch (action.type) {
    case INSTITUTION_SUCCESS:
      return { ...action.payload.data };
    case INSTITUTION_FAIL:
      return state;
    case LOAD_INSTITUTION:
      return { ...action.institution };
    default:
      return state;
  }
}
